import { render, staticRenderFns } from "./OffenceCard.vue?vue&type=template&id=f779722e"
import script from "./OffenceCard.vue?vue&type=script&lang=js"
export * from "./OffenceCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports